import { FormInput } from "@4uhub/lib4uhub";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import { Box, IconButton } from "@mui/material";
import { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { IPasswordFieldProps } from "./models";

const translationPath = "page.totem_start.";

export const PasswordField = memo(({ colors }: IPasswordFieldProps) => {
  const { t } = useTranslation();

  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPasswordHandler = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  return (
    <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
      <FormInput
        fullWidth
        margin="normal"
        label={t(translationPath + "password")}
        type={showPassword ? "text" : "password"}
        name="password"
        inputProps={{ style: { paddingRight: 45 } }}
        sx={{
          "& label.Mui-focused": {
            color: colors.secondary,
          },
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderColor: colors.secondary,
            },
          },
        }}
      />
      <IconButton
        size="small"
        sx={{ mt: 1, position: "absolute", right: 10 }}
        onClick={toggleShowPasswordHandler}
      >
        {!showPassword ? (
          <VisibilityRoundedIcon fontSize="small" />
        ) : (
          <VisibilityOffRoundedIcon fontSize="small" />
        )}
      </IconButton>
    </Box>
  );
});
